import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@material-ui/core";
import CobeeTextField from "../../../../../app/components/CobeeTextField";
import useStyles from "../../styles";

export default function RowCustomQuota({ renting, setRenting, title, label }) {
  const { secondColumn, fieldRowSpacing, inputLabel, inputTopLabel } =
    useStyles();
  return (
    <>
      <Grid container item justify="flex-end" xs={12}>
        <Grid
          item
          xs={6}
          container
          alignItems="center"
          className={secondColumn}
        >
          <Grid item xs={12} className={inputTopLabel}>
            <Typography variant="body2">{title}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid container item justify="flex-end" xs={12}>
        <Grid
          item
          xs={6}
          container
          alignItems="center"
          className={secondColumn}
        >
          <Grid
            item
            xs={12}
            container
            alignItems="center"
            className={fieldRowSpacing}
          >
            <Grid item xs={4}>
              <CobeeTextField
                type="number"
                minWidth="100%"
                min={0}
                value={renting}
                onChange={(e) => setRenting(e.target.value)}
              />
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body2" className={inputLabel}>
                {`EUR (${label})`}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

RowCustomQuota.propTypes = {
  renting: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setRenting: PropTypes.func,
  title: PropTypes.string,
  label: PropTypes.string,
};

RowCustomQuota.defaultProps = {
  renting: "0",
  setRenting: () => {},
  title: "",
  label: "",
};
